<template>
  <div @contextmenu.prevent class="wrap">
    <div class="container-fluid">
    <div class="book-preview-header" ref="back_header">
      <div class="ebook_name_content">
      <div class="txt-ellipsis" :style="{width: header_width}">
        <div class="book-preview-header_back_button" >
          <el-button  @click="$router.back(-1)" class="header_back" type="text" icon="el-icon-back"></el-button>
          <div class="audit_area">
            <el-button size="small"
                       v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])&&!isPublicEbook&&isShowBtn"
                       @click="dialogVisible = true"
                       type="primary">驳回
            </el-button>
            <el-button size="small"
                       @click="ebookPass"
                       v-if="$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])&&!isPublicEbook&&isShowBtn&&alreadyPass"
                       type="primary">通过</el-button>
            <el-button @click="approvedMemo" size="small" v-if="!isPublicEbook" type="primary">审核记录</el-button>
          </div>
        </div>
        <span class="book-title" :title="`《${eBookDetailData.ebook_name}》${eBookDetailData.author_name}`">《{{eBookDetailData.ebook_name}}》<span>{{eBookDetailData.author_name}}</span></span>
      </div>
      </div>
    </div>
    <ebookInformation :query-params="queryParams" ></ebookInformation>
    <el-dialog
      title="驳回"
      :visible.sync="dialogVisible"
      @closed="$refs['rejectForm'].clearValidate()"
      width="50%">
      <el-form ref="rejectForm" @submit.native.prevent label-width="80px" :model="ruleForm" :rules="rules">
        <el-form-item label="驳回原因" prop="reject">
          <el-input  placeholder="请输入驳回信息" v-model="ruleForm.reject" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitTurn">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="审核记录" :visible.sync="dialogTableVisible">
      <el-row v-for="(item,index) in eBookApprovedMemoData.list" :key="index">
        <el-col :span="9"><div>{{item.verify_at||'暂无'}}</div></el-col>
        <el-col :span="7"><div>{{item.verify_remark||'暂无'}}</div></el-col>
        <el-col :span="8">
          <div>{{item.verify_status|verifyStatus}}</div>
        </el-col>
      </el-row>
      <span v-if="eBookApprovedMemoData.list.length === 0">......暂时没有审核记录</span>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="dialogTableVisible=false">确 定</el-button>
        </span>
    </el-dialog>
  </div></div>
</template>

<script>
  import ebookInformation from "./components/index"
  import{
    mapGetters,
    mapActions
  } from 'vuex';
  import {
    throttle
  } from 'lodash';

  export default {
    components: {
      ebookInformation
    },
    data() {
      return {
        header_width: '',
        dialogVisible : false,
        dialogTableVisible:false,
        ruleForm:{
          reject:'',
        },
        rules:{
          reject: [
            { required: true, message: '请输入驳回原因', trigger: 'blur' },
            { min: 3,max:999999, message: '最少3个字符', trigger: 'blur' }
          ],
        }
      };
    },
    computed:{
      ...mapGetters({
        'user': '__get_user_info',
        'eBookDetailData': 'getPublisherEBookDetailData',//详情
        'eBookApprovedMemoData': 'getEBookApprovedMemoData',//审核详情
      }),
      alreadyPass(){
       return this.eBookDetailData.status !==3
      },
      isPublicEbook() {
        return this.$route.name.indexOf('e_book') !== -1;
      },
      isShowBtn(){
        return this.$route.query.isCorrect?false:true;
      },
/*      isDisabled(){
        return this.eBookDetailData.published_at?true:false;
      },*/
      queryParams() {
        let query = this.$route.query;
        return {
          ebook_id: query.ebook_id,
          ebook_category_content_id: query.ebook_category_content_id,
          anchor: query.anchor
        }
      }
    },
    filters:{
      verifyStatus(val){
        return {
          1:'待审核',
          2:'审核已拒绝',
          3:'审核通过',
        }[val]
      }
    },

    methods: {
      ...mapActions({
        'functionEBookAdminIndexPassOrRejectPort':'actionEBookAdminIndexPassOrRejectPort',//电子书驳回
        'functionEBookApprovedMemoData':'actionEBookApprovedMemoDataPort',//审核记录
      }),
      approvedMemo(){
        this.functionEBookApprovedMemoData({
          ebook_id:this.$route.query.ebook_id
        }).then(()=>{
          this.dialogTableVisible = true
        })

      },
      //通过
      ebookPass(){
        this.$confirm('您确认要通过本书吗', '通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.functionEBookAdminIndexPassOrRejectPort({
            ebook_id:this.$route.query.ebook_id,
            action:'pass',
          }).then(()=>{
            this.$message.success("驳回成功");
            this.$router.replace({
              name:'publisher_books_management'
            })
          })
        })
      },
      //驳回
      submitTurn(){
        this.$refs['rejectForm'].validate((valid)=>{
          if(valid){
            this.functionEBookAdminIndexPassOrRejectPort({
              ebook_id:this.$route.query.ebook_id,
              action:'reject',
              verify_remark:this.ruleForm.reject,
            }).then(()=>{
              this.dialogVisible = false;
              this.$message.success("驳回成功");
              this.$router.replace({
                name:'publisher_books_management'
              })
            })
          }
        })
      },
      initHeaderWidth() {
        this.header_width = this.$refs['back_header'].getBoundingClientRect()['width'] + 'px';
      },
      startWatchHeaderWith() {
        if ( ! (typeof this.__watchFn === 'function') ) {
          this.__watchFn = throttle(() => {
            this.initHeaderWidth();
          }, 300);
          addEventListener('resize', this.__watchFn, false);
        }
      },
      stopWatchHeaderWith() {
        removeEventListener('resize', this.__watchFn, false);
      }
    },
    mounted() {
      this.initHeaderWidth();

      this.startWatchHeaderWith();
    },
    beforeDestroy() {
      this.stopWatchHeaderWith();
    }
  }
</script>
<style scoped>
  .audit_area{
    padding-top: 15px;
    width: 280px;
    height: 52px;
    position: absolute;
    right: 0;
    top: 0;
  }
</style>

<style lang="less" scoped>
  .wrap{
    padding: 20px;
    min-width: 900px;
    overflow: hidden;
  }

  .page-container{
    background-color: transparent;
    
  }

  .book-preview-header {
    height: 40px;
    text-overflow: ellipsis;

    > div {
      position: fixed;
      background-color: #fff;
      top: 80px;
      z-index: 999;
      margin-top:  -20px;
      padding-top: 20px;
    }
    .txt-ellipsis {
      padding-left: 20px;
      padding-bottom:20px;
      border-bottom:1px solid #E1E6F0;
    }
    .book-preview-header_back_button {
      max-width: 100%;
      width: 30px;
      height: 30px;
      background-color: black;
      border-radius: 50%;
      display: inline-block;
      z-index:1000;
      text-align: center;
    }

    .book-title {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .header_back {
    color: white;
    font-size: 16px;
    margin-top: -5px;
  }
  .ebook_name_content{
    background: #FFF;
  }
</style>
